import React, { useEffect, useState } from 'react'
import orderService from '../../services/order.service';
import {message,Spin,Modal} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';
import {history} from '../../helpers/history';
import { getUserCoins } from '../../actions/coinsAction';



const spinIcon = <LoadingOutlined style={{ fontSize: 24,color:'white' }} spin />; 
const loadRazorpay = (src)=>{
    return new Promise((resolve)=>{
        const script = document.createElement('script');
        script.src = src;
        
        script.onload = ()=>{
            resolve(true);
        }

        script.onerror = ()=>{
            resolve(false);
        }
        document.body.appendChild(script);
    })
}

const Razorpay= ({amount,qty,order,isPartial,coins,orderAmount,rate})=> {
    const [keyId,setKeyId] = useState(null);
    const [loading,setLoading] = useState(false);
    const [address,setAddress] = useState(null);
    const [city,setCity] = useState(null);
    const [state,setState] = useState(null);
    const [pinCode,setPinCode] = useState(null);
    const [country,setCountry] = useState(null);
    const { user: currentUser } = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    

    useEffect(()=>{
        getConfig();
    },[])
    const getConfig = async ()=>{
        try{
            const response = await orderService.getRazorpayConfig();
            setKeyId(response.data.key_id);

        }catch(err){
            console.log(err);
            message.error(err.message);
        }
    }


const setPaymentDetails = async (paymentDetails)=>{

        let finalData = {
            fName:currentUser.name,
            email:currentUser.email,
            address:address,
            city:city,
            state:state,
            country:country,
            pinCode:pinCode,
            order:order,
            user:currentUser.id,
            qty:qty,
            amount:amount*rate,
            orderAmount:orderAmount*rate,
            currency:"INR",
            isPartial:isPartial,
            paymentIntent:null,
            status:'succeeded',
            rate:rate,
            paymentMethod:'Razorpay',
            remainingAmount: isPartial && ((Number(order.totalAmount)*rate)-(Number(order.paidAmount))*rate)-(Number(order.partialAmount)*rate),
            discountApplied:coins ? coins*rate : 0
          }

        // console.log("FINAL DATA : ",finalData);
        // console.log("PAYMENT RESPONSE",paymentDetails);

        try{
            let response = await orderService.setOrderPayment(finalData);
                // console.log(response.data);
            let coinsResponse = await orderService.updateCoinsAfterDeliver({userId:currentUser.id,coins:coins});
            // console.log(coinsResponse);
            if(coinsResponse){
              
                dispatch(getUserCoins({userId:currentUser.id}));
              
            }
                setLoading(false);
                successModal();
               
        }catch(err){
            message.error(err.message ? err.message : err);
            setLoading(false);
            errorModal();
        }
        
    }
   


    const paymentHandler = async (e) => {
        setLoading(true);
       const res = await loadRazorpay("https://checkout.razorpay.com/v1/checkout.js");

       if(!res){
           errorModal('Razorpay Failed To Load!');
           setLoading(false);
           return;
       }
        e.preventDefault();
       try{

        const response = await orderService.makeRazorpayPayment({amount:parseInt(Number(amount*rate))});
        const { data } = response;
        const options = {
          key: keyId,
          amount:data.amount.toString,
          currency:data.currency,
          name: "Codersarts",
          description: "Get Assignment Help Easily...",
          image:"data:image/png;base64,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",
          order_id: data.id,
          handler: async (response) => {
            // console.log(response);
            setLoading(false);
            setPaymentDetails(response);
          },
          prefill:{
              name:currentUser.name,
              email:currentUser.email
          },
          theme: {
            color: "#013f4d"
          },
        };
        const rzp1 = new window.Razorpay(options);
        rzp1.open();

       }catch(err){
         setLoading(false);
         errorModal(err.message);
       }
    };



    function successModal() {
        let secondsToGo = 5;
        const modal = Modal.success({
          title: 'Payment is Successful !',
          content: `You will be redirected to Orders page in ${secondsToGo} second.`,
        });
        const timer = setInterval(() => {
          secondsToGo -= 1;
          modal.update({
            content: `You will be redirected to Orders page in  ${secondsToGo} second.`,
          });
        }, 1000);
        setTimeout(() => {
          clearInterval(timer);
          modal.destroy();
          history.push('/profile/user-orders');
        }, secondsToGo * 1000);
      }

      function errorModal(title='Something Went Wrong !') {
        let secondsToGo = 5;
        const modal = Modal.error({
          title: title,
          content: `Please Try Again in ${secondsToGo} second.`,
        });
        const timer = setInterval(() => {
          secondsToGo -= 1;
          modal.update({
            content: `Please Try Again in  ${secondsToGo} second.`,
          });
        }, 1000);
        setTimeout(() => {
          clearInterval(timer);
          modal.destroy();
        }, secondsToGo * 1000);
      }


    return (
        <div className="d-flex">
            <div className="pay-color-panel">
            <h5 style={{marginLeft:'0%',marginBottom:'2%'}}>Payment for Codersarts Services</h5>
            <hr style={{color:'white',height:'5px'}}/>
              <div style={{color:'white',marginTop:'4%'}}>
              <h6 style={{color:'white'}}>Contact Us:</h6>
              <hr style={{color:'white',width:'100px',height:'3px'}} />
              <div>
                <i class="fa fa-envelope" aria-hidden="true"></i>
                <span style={{marginLeft:'3%'}}>contact@codersarts.com</span>
              </div>
              <div>
                <i class="fa fa-phone" aria-hidden="true"></i>
                <span style={{marginLeft:'3%'}}>7292007989</span>
              </div>
              </div>
               <div style={{color:'white',marginTop:'4%'}}>
              <h6 style={{color:'white'}}>Terms And Condition</h6>
              <hr style={{color:'white',width:'170px',height:'3px'}} />
              Codersarts is product for Sofstack Solution Pvt Ltd. Read more:
              <a style={{marginLeft:'3%'}} href="https://www.codersarts.com/terms-of-service" target="_blank">
              https://www.codersarts.com/terms-of-service
              </a>
              </div>
              
          </div>

          <div>
            <h4><b>Inside India Clients</b></h4>
            <hr style={{height:'5px',width:'20vw',marginBottom:'8%'}} />
          
                <>
                <div className="form-group">
                <div>
                <label className="mt-2"><b>Billing Details</b></label>
                <textarea type="text" 
                placeholder="Address" 
                className="form-control m-2" value={address} onChange={e=>setAddress(e.target.value)}
                style={{height:'6rem',width:'30vw',resize:'none'}}/>
              <div className="d-flex">
               <div >
                <input type="text" style={{width:'14.4vw'}} value={city} onChange={e=>setCity(e.target.value)} className="form-control m-2" placeholder="City" />
                <input type="text" style={{width:'14.4vw'}}  value={state} onChange={e=>setState(e.target.value)} className="form-control m-2" placeholder="State" />
               </div>
                <div>
                <input type="text" style={{width:'14.4vw'}} maxLength={10} value={pinCode} onChange={e=>setPinCode(e.target.value)} className="form-control m-2" placeholder="Postal Code" />
                <input type="text" style={{width:'14.4vw'}} value={country} onChange={e=>setCountry(e.target.value)} className="form-control m-2" placeholder="Country" />
                </div>
              </div>

                </div>
               
               </div>
               <div className="form-group d-flex" >
                  <button style={{width:'100%'}} disabled={loading || address==null || pinCode===null || city ===null || country===null}  className="pay-btn" onClick={paymentHandler}>
                  {loading ? <Spin indicator={spinIcon} /> : 'Pay Now'}
                  </button>
                </div>
                  
                </>
        
         
           
           </div>
        </div>
    )
}

export default Razorpay
